export enum DialogActionTypes {
  RESEND_VERIFICATION = 'resendVerification',
  CLOSE_DIALOG = 'closeDialog',
  SAVE_ROLES_CHANGES = 'saveRolesChanges',
  SUBMIT_MESSAGE = 'submitMessage',
  INIT_CHAT_ROOM = 'initChatroom',
  SUBMIT = 'submit',
  CONFIRM_ACTION = 'confirmAction',
  GO_TO_HOMEPAGE = 'goToHomepage',
  GO_TO_LOGIN_PAGE = 'goToLoginPage',
  GO_TO_SECOND_AUTH_PAGE = 'goToSecondAuthPage',
  GO_TO_CONNECTIONS = 'goToConnections',
  RESET_CONVERSATION_TITLE = 'resetConversationTitle',
  GO_TO_REGISTRATION = 'registrationLink',
  SEND_REACTIVATION_PETITION = 'sendReactivationPetition',
}

export enum DialogTypes {
  DEFAULT = 'dialogDefault',
  CONFIRM = 'dialogConfirm',
  SEND_MESSAGE = 'sendMessage',
  ROLE_SELECT = 'individualRoleSelect',
  ACTIVITIES = 'showActivities',
  CROP = 'dialogCrop',
  DEACTIVATE_ACCOUNT = 'deactivateAccount',
  SEND_REACTIVATION_PETITION = 'sendReactivationPetition',
  ADMIN_DECLINE_PETITION = 'adminDeclinePetition',
  USER_INFO_DISPLAY = 'userInfoDisplay',
  CONVERSATION_TITLE_EDIT = 'conversationTitleEdit',
  SAVE_DATA = 'unsavedChanges',
  INVITE_ADMIN = 'inviteAdmin',
  INFORMATION_DIALOG = 'informationDialog',
  CREATE_CATEGORY = 'createCategory',
  UPDATE_CATEGORY = 'updateCategory',
}
